// extracted by mini-css-extract-plugin
export default {"container":"ImageGroup_container__mu4vH","block":"ImageGroup_block__u2upz","image":"ImageGroup_image__ef6dv","text":"ImageGroup_text__uTLGR"};